.root {
	position: absolute;
	cursor: pointer;
	pointer-events: initial;
	z-index: var(--jpo-z-index-issue-arrow);
}
